<div class="modal-header pt-1 mb-1 position-relative">
  <h2 class="modal-title text-center mx-auto" id="modal-confirm-title">
    <span class="d-inline-block ms-1" translate>Developer Info</span>
  </h2>
  <button class="btn-close btn-red" (click)="dismiss()"></button>
</div>
<div class="modal-body">
  <h3>Push notification Token</h3>
  @if(currentFCMToken()) {
  <div class="d-flex justify-content-between align-items-center">
    <div class="text-break fw-bold col ps-0" (click)="copyTokenInClipboard()">
      {{ currentFCMToken() }}
    </div>
    <button class="btn btn-info rounded-1 ms-1" (click)="copyTokenInClipboard()" translate>
      <i class="icon icon-copy"></i>
    </button>
  </div>
  }@else {
  <div>
    <b>Token not available</b>
  </div>
  }

  <hr />
</div>
